import styled from 'styled-components';
import { select } from '../../../core/themev2';
import { getColor } from '../../../core/themev3';

const ContainerModal = styled.div`
  margin: 24px;
`;
const NavigationButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;

const Button = styled.button.attrs({ type: 'button' })`
  height: 40px;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 12px;
  border-radius: 8px;
  color: ${select('white')};
  background-color: ${getColor('primary')};
  cursor: pointer;

  :hover {
    background-color: ${getColor('secondary')};
  }

  &.start-button {
    width: 100%;
  }

  &.prev-button {
    background-color: ${select('white')};
    color: ${select('black')};
    :hover {
      background-color: ${select('neutralDarkGray')};
    }
  }
`;

const ContainerS1 = styled.div`
  width: ${({ device }) => (device === 'mobile' ? '100%' : '384px')};
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  .title {
    text-align: center;
    font-family: Hind;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    width: 250px;
    white-space: normal;
  }
  p {
    text-align: center;
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: normal;
  }
`;

/* Level Component: */
const LevelContainer = styled.div`
  text-align: center;
`;

const LevelTitle = styled.h2`
  color: ${({ color }) => select(color || 'black')};
  font-family: Hind;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px;
`;

const LevelBlocks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 10px;
`;

const Block = styled.div`
  width: ${({ active }) => (active ? '92px' : '46px')};
  height: 8px;
  background-color: ${({ color }) => select(color)};
  opacity: ${({ active }) => (active ? 1 : 0.2)};
`;

/* StepIndicator Component: */
const StepIndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

const StepCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ active }) => select(active ? 'midDarkGrayAux' : 'midNeutralGray')};
`;

export {
  ContainerModal,
  NavigationButtons,
  Button,
  StepIndicatorContainer,
  StepCircle,
  LevelContainer,
  LevelTitle,
  LevelBlocks,
  Block,
  ContainerS1
};
